export default __webpack_public_path__ + "static/media/integration-sync.3e5ae33c.png";